/**
 * Utility for thermal printing using a hidden iframe.
 * Faster and more reliable on mobile than libraries that clone the whole document.
 */
export const printThermal = (htmlContent) => {
  if (!htmlContent) return;

  const iframe = document.createElement('iframe');
  Object.assign(iframe.style, {
    position: 'fixed',
    right: '0',
    bottom: '0',
    width: '0',
    height: '0',
    border: '0',
  });

  document.body.appendChild(iframe);

  const content = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Imprimir Cupom</title>
        <style>
          @media print {
            @page {
              size: 80mm auto;
              margin: 0;
            }
            html, body {
              margin: 0 !important;
              padding: 0 !important;
              width: 80mm !important;
              height: auto !important;
              font-family: 'Roboto', Helvetica, Arial, sans-serif;
            }
            .sale-resume-print {
              display: block;
              width: 100%;
              padding: 5mm;
              box-sizing: border-box;
            }
          }
        </style>
      </head>
      <body>
        ${htmlContent}
      </body>
    </html>
  `;

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(content);
  doc.close();

  iframe.onload = () => {
    setTimeout(() => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (e) {
        console.error('Print failed', e);
      }
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 1000);
    }, 500);
  };
};
